import React from 'react';
import TransactionHistoryPage from '@/components/monetization/TransactionHistoryPage';

export default function Transactions() {
  return <TransactionHistoryPage />;
}
